<script>
import VueDropify from "vue-dropify";
import Drawer from "@/components/drawer";
import VueHtml2pdf from "vue-html2pdf";
import { required } from "vuelidate/lib/validators";
import VueQRCodeComponent from "vue-qrcode-component";

// Custom Components
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";

export default {
  page: {
    title: "Hotel Directory",
  },
  components: {
    Drawer,
    VueDropify,
    VueHtml2pdf,
    VueQRCodeComponent,
  },
  data() {
    return {
      title: "Hotel dashboard",
      openEditTemplate: false,
      scanData: {
        title: "Your Hotel Guide",
        smallTitle: "Victorville, CA 94404",
        logo: null,
      },
      imgUrl: null,
      submittedData: false,
      isBtnLoading: false,
      size: 150,
      linkUrl: null,
      qrUrl: null,
      wifiUrl: null,
    };
  },
  computed: {
    ...authComputed,
  },
  validations: {
    scanData: {
      title: {
        required,
      },
      smallTitle: {
        required,
      },
      logo: {
        required,
      },
    },
  },
  mounted() {
    this.manageData();
    this.linkUrl =
      process.env.VUE_APP_GUEST_PORTAL_BASE_URL +
      `?app_type=hd&hc=${this.hotel.property_code}&utm_source=link`;
    this.wifiUrl =
      process.env.VUE_APP_GUEST_PORTAL_BASE_URL +
      `?location=${this.hotel.id}&mac=6032b1700bd8&client_mac=12c3d6446402&client_ip=192.168.1.19&utm_source=link`;
    this.qrUrl =
      process.env.VUE_APP_GUEST_PORTAL_BASE_URL +
      `?app_type=hd&hc=${this.hotel.property_code}&utm_source=qr_code`;
  },
  methods: {
    manageData() {
      this.scanData.logo = this.hotel.logo;
    },
    editTemplate() {
      this.openEditTemplate = !this.openEditTemplate;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    changeImage(event) {
      if (event[0] !== undefined) {
        this.imgUrl = event[0];
      }
    },
    async handleSubmit() {
      try {
        this.submittedData = true;
        this.isBtnLoading = true;
        this.$v.$touch();
        if (this.$v.scanData.$invalid) {
          this.isBtnLoading = false;
          return;
        } else {
          let data = { ...this.scanData };
          if (typeof data.logo == "string") {
            delete data.logo;
          }
          if (this.imgUrl !== null) {
            this.scanData.logo = window.URL.createObjectURL(this.imgUrl);
            data.logo = this.imgUrl;
          }
          const scanFormData = new FormData();
          Object.keys(data).map((key) => {
            if (data[key] !== null) {
              scanFormData.append(key, data[key]);
            }
          });
          Middleware.notification("Details successfully updated !!", "success");

          this.isBtnLoading = false;
          this.submittedData = false;
          this.editTemplate();
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    openGuestPortal() {
      window.open(this.linkUrl, "_blank");
    },
    // Method is used to copy code
    copyCode(code) {
      Middleware.copyCode(code);
    },
  },
};
</script>

<template>
  <div>
    <b-card class="card-height">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-xl-8">
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Visit Today</p>
                        <h5 class="mb-0">23</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                        >
                          <i class="fas fa-glasses"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Avg time spent</p>
                        <h5 class="mb-0">5 min</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                        >
                          <i class="bx bxs-time-five"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Rating & feedback</p>
                        <h5 class="mb-0">11</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                        >
                          <i class="fas fa-star-half-alt"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Service Request</p>
                        <h5 class="mb-0">11</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                        >
                          <i class="fab fa-servicestack"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">FrontDesk Call</p>
                        <h5 class="mb-0">12</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                        >
                          <i class="fas fa-headset"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <vue-html2pdf
                  :show-layout="false"
                  :float-layout="true"
                  :enable-download="true"
                  :preview-modal="false"
                  :filename="'qrCodeCard'"
                  :pdf-quality="2"
                  :manual-pagination="true"
                  pdf-format="a6"
                  pdf-orientation="portrait"
                  @hasGenerated="hasGenerated($event)"
                  ref="html2Pdf"
                >
                  <section slot="pdf-content">
                    <div class="card card-template mb-0 border-0">
                      <div class="bg-primary rounded-top">
                        <div class="p-3 pb-0">
                          <h3 class="theme-span text-center px-4">
                            {{ scanData.title }}
                          </h3>
                          <p class="text-center text-light px-2 mb-3">
                            {{ scanData.smallTitle }}
                          </p>
                          <span v-if="qrUrl !== null">
                            <div class="angle-1">
                              <VueQRCodeComponent
                                :text="qrUrl"
                                :size="size"
                                level="H"
                                class="d-block mx-auto qr-code-scan-img cursor"
                              ></VueQRCodeComponent>
                              <div class="angle-2"></div>
                            </div>
                          </span>
                          <h5
                            class="d-flex align-items-center justify-content-center text-light mt-2"
                            @click="openGuestPortal"
                          >
                            {{ hotel.property_code }}
                          </h5>
                        </div>
                      </div>
                      <svg
                        class="w-100 mt-n1"
                        height="60"
                        viewBox="0 0 500 80"
                        preserveAspectRatio="none"
                      >
                        <path
                          d="M0,0 L0,40 Q250,80 500,40 L500,0 Z"
                          fill="#238dfa"
                        />
                      </svg>
                      <div class="text-center">
                        <img
                          :src="
                            scanData.logo !== null ? scanData.logo : hotel.logo
                          "
                          alt=""
                          class="img-logo mb-2"
                          @click="generateReport()"
                        />
                        <h6 class="p-3 mb-0">
                          Powered by
                          <span class="cursor" v-if="qrUrl !== null">{{
                            qrUrl.split("?")[0].replace("https://", "")
                          }}</span>
                        </h6>
                      </div>
                    </div>
                  </section>
                </vue-html2pdf>

                <div class="card card-template mb-0">
                  <div class="bg-primary rounded-top">
                    <div class="p-3 pb-0">
                      <i
                        class="fas fa-pencil-alt fs-4 text-light"
                        @click="editTemplate"
                      ></i>
                      <h3 class="theme-span text-center px-4">
                        {{ scanData.title }}
                      </h3>
                      <p class="text-center text-light px-2 mb-3">
                        {{ scanData.smallTitle }}
                      </p>
                      <span v-if="qrUrl !== null">
                        <div class="angle-1">
                          <VueQRCodeComponent
                            :text="qrUrl"
                            :size="size"
                            level="H"
                            class="qr-code-scan-img cursor"
                          ></VueQRCodeComponent>
                          <div class="angle-2"></div>
                        </div>
                      </span>
                      <h5
                        class="d-flex align-items-center justify-content-center text-light mt-2"
                        @click="openGuestPortal"
                      >
                        {{ hotel.property_code }}
                      </h5>
                    </div>
                  </div>
                  <svg
                    class="w-100 mt-n1"
                    height="60"
                    viewBox="0 0 500 80"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0,0 L0,40 Q250,80 500,40 L500,0 Z"
                      fill="#238dfa"
                    />
                  </svg>
                  <div class="text-center">
                    <img
                      :src="scanData.logo !== null ? scanData.logo : hotel.logo"
                      alt=""
                      class="img-logo mb-2"
                      @click="generateReport()"
                    />
                    <h6 class="p-3 mb-0" v-if="qrUrl !== null">
                      Powered by
                      <span class="cursor" @click="openGuestPortal">{{
                        qrUrl.split("?")[0].replace("https://", "")
                      }}</span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4">
            <div class="card mb-3">
              <div class="card-body">
                <h4 class="text-center mb-3">Top 5 Pages Visited</h4>
                <div class="d-flex justify-content-between border-bottom mb-3">
                  <h5>Name</h5>
                  <h5>Visitor</h5>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-6">
                      <p class="mb-0 text-truncate">Hotel Directory</p>
                    </div>
                    <div class="col-1">
                      <i
                        class="fas fa-arrow-right text-center d-block fs-5"
                      ></i>
                    </div>
                    <div class="col-5">
                      <p class="text-end mb-0">5</p>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-6">
                      <p class="mb-0 text-truncate">Nearby Places</p>
                    </div>
                    <div class="col-1">
                      <i
                        class="fas fa-arrow-right text-center d-block fs-5"
                      ></i>
                    </div>
                    <div class="col-5">
                      <p class="text-end mb-0">2</p>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-6">
                      <p class="mb-0 text-truncate">TV Channel List</p>
                    </div>
                    <div class="col-1">
                      <i
                        class="fas fa-arrow-right text-center d-block fs-5"
                      ></i>
                    </div>
                    <div class="col-5">
                      <p class="text-end mb-0">2</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <label for="guest_code">Guest Code</label>
                <div class="d-flex align-items-center mb-3">
                  <b-form-input
                    id="room_type"
                    type="text"
                    placeholder="name"
                    autocomplete="off"
                    :value="linkUrl"
                  ></b-form-input>
                  <i
                    class="fas fa-clone text-primary fs-5 ms-2"
                    id="code"
                    @click="copyCode(linkUrl)"
                  ></i>
                </div>
                <label for="wifi_portal">Wifi Portal</label>
                <div class="d-flex align-items-center mb-3">
                  <b-form-input
                    id="room_type"
                    type="text"
                    placeholder="name"
                    autocomplete="off"
                    :value="wifiUrl"
                  ></b-form-input>
                  <i
                    class="fas fa-clone text-primary fs-5 ms-2"
                    id="code"
                    @click="copyCode(wifiUrl)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>
    <Drawer
      @close="editTemplate"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :maxWidth="675"
      :zIndex="1002"
    >
      <div v-if="openEditTemplate">
        <div class="col-md-12">
          <h4>HomePage Template</h4>
          <hr />
          <form ref="header-form" @submit.stop.prevent="handleSubmit">
            <div class="mb-3">
              <label for=""> Title <span class="text-danger">*</span> </label>
              <b-form-input
                id="title"
                type="text"
                placeholder="title"
                autocomplete="off"
                :class="{
                  'is-invalid': submittedData && $v.scanData.title.$error,
                }"
                v-model="scanData.title"
              ></b-form-input>
              <div
                v-if="submittedData && $v.scanData.title.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.scanData.title.required"
                  >Title is required.</span
                >
              </div>
            </div>
            <div class="mb-3">
              <label for=""
                >company logo <span class="text-danger">*</span></label
              >
              <VueDropify
                @upload="changeImage($event)"
                message="Drop thumbnailImage or click here to select"
                height="150px"
                width="100%"
                id="icon"
                :src="scanData.logo"
                class="mb-3 w-100"
                :class="{
                  'is-invalid': submittedData && $v.scanData.logo.$error,
                }"
              />
              <div
                v-if="submittedData && $v.scanData.logo.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.scanData.logo.required">Icon is required.</span>
              </div>
            </div>
            <div class="mb-3">
              <label for="">
                small title <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="small_title"
                type="text"
                placeholder="small title"
                autocomplete="off"
                v-model="scanData.smallTitle"
                :class="{
                  'is-invalid': submittedData && $v.scanData.smallTitle.$error,
                }"
              ></b-form-input>
              <div
                v-if="submittedData && $v.scanData.smallTitle.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.scanData.smallTitle.required"
                  >Text is required.</span
                >
              </div>
            </div>
            <div>
              <b-button
                class="float-end ms-2"
                variant="outline-primary"
                type="reset"
                @click="editTemplate"
                >Cancel</b-button
              >
              <b-button
                class="float-end"
                variant="outline-primary"
                @click="handleSubmit"
                :class="{ disabled: isBtnLoading }"
                ><i
                  v-if="isBtnLoading"
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                ></i
                >Save
              </b-button>
            </div>
          </form>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<style>
.card-template {
  width: 400px;
}
.card-template i {
  position: absolute;
  top: 16px;
  right: 16px;
}
.pdf-content {
  width: 400px;
  min-height: 550px;
}
.theme-span {
  font-weight: 500;
  letter-spacing: 1px;
  -webkit-text-stroke: 1px rgb(255, 255, 255);
  color: #fff;
  text-transform: uppercase;
}
.qr-code-scan-img {
  position: relative;
  z-index: 0;
}
.qr-code-scan-img img {
  margin: auto;
  padding: 8px 6px;
}
.qr-code-scan-img::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 10px;
  width: 1px;
  color: #fff;
  z-index: 111;
}

.angle-1 {
  max-height: 180px;
  max-width: 170px;
  margin: auto;
  position: relative;
}

.angle-1:after,
.angle-1:before,
.angle-2:after,
.angle-2:before {
  content: "";
  display: block;
  position: absolute;
  width: 2vw;
  height: 2vw;
  border: 0.2rem solid transparent;
}

.angle-1:after,
.angle-1:before {
  top: 0;
  border-top-color: #fff;
}

.angle-2:after,
.angle-2:before {
  bottom: 0;
  border-bottom-color: #fff;
}

.angle-1:before,
.angle-2:before {
  left: 0;
  border-left-color: #fff;
}

.angle-1:after,
.angle-2:after {
  right: 0;
  border-right-color: #fff;
}
</style>
